// extracted by mini-css-extract-plugin
module.exports = {"container":"DM","modal":"EM"};